// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n.animation-container[data-v-b6304d1c] {\n  width: 100%;\n  height: 100%;\n  /* 防止容器闪烁 */\n  transform: translate3d(0, 0, 0);\n  backface-visibility: hidden;\n  perspective: 26.666667rem;\n}", ""]);
// Exports
module.exports = exports;
